import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  /**
   * Pas envie de gérer les callback comme sur Java, on est où là ?
   */
  public onCookieConsentChange: (value: string) => void;

  public notifyCookieConsentChange(value: string): void {
    this.onCookieConsentChange(value);
  }
}
